'use client';

import Composer from '@/common/Composer';
import VdpComposerSlot from '@/vdp/ComposerUi/VdpComposerSlot';
import { useShowComposerTreatment } from '~/context/composer/ComposerContext';

export default function VdpComposerUi() {
  const showComposerTreatment = useShowComposerTreatment();

  if (!showComposerTreatment) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-40">
      <Composer
        inputPlaceholder="Ask about this car or keep searching"
        slot={<VdpComposerSlot />}
      />
    </div>
  );
}
